// 推送接口使用，素材制作方式来源
export enum MaterialMakeFrom {
  Custom = 1, // 交付列表
  Dmaker = 2, // 在线制作
  Gmaker = 3, // 通用模板
  Playsmart = 4, // PlaySmart
  Veditor = 5, // VEditor
}
